import React, { useState } from "react";
import ReactDOM from 'react-dom/client';
import './index.css';
import { GoogleLogin, googleLogout, GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

function Root() {

  const [user, setUser] = useState(null);

  const allowedEmails = ["milinjani@gmail.com"];

const handleLoginSuccess = async (credentialResponse) => {
  try {
    // Decode Google ID token
    const decoded = jwtDecode(credentialResponse.credential);

    if (!allowedEmails.includes(decoded.email)) {
      alert("Unauthorized email. Access denied.");
      googleLogout();
      return;
    }

    // Create PHP session
    const res = await fetch("/functions/trackapi/auth.php", {
      method: "POST",
      credentials: "include", // REQUIRED for PHP sessions
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email: decoded.email,
        name: decoded.name
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error("Auth failed: " + text);
    }

    const data = await res.json();

    if (!data.ok) {
      throw new Error(data.error || "Auth rejected");
    }

    // Session confirmed → allow app
    setUser({
      email: decoded.email,
      name: decoded.name,
      picture: decoded.picture
    });

  } catch (err) {
    console.error("Login error:", err);
    alert("Login failed. Please try again.");
    googleLogout();
  }
};


  const handleLogout = () => {
    setUser(null);
    googleLogout();
  };



  return (
    <GoogleOAuthProvider clientId="67029705784-m9sk9t7cm2kqn6pktbhkhvs92hf0ura9.apps.googleusercontent.com">
      {!user ? (
        <div className="d-flex flex-column align-items-center mt-5">
          <h4>DJ ILL'N Tracks</h4>

          <GoogleLogin
            onSuccess={handleLoginSuccess}
          />
        </div>
      ) : (
        <App handleLogout={handleLogout} />
      )}
    </GoogleOAuthProvider>
  );

};

root.render(<Root />);


